import { useEffect, useRef, useState } from 'react';

export const MOVING_KMH = 10;
export const MOVING_WINDOW_MS = 60 * 1000;
export const MOVING_MIN_UPDATES = 3;

/**
 * True while the position is reported as faster than MOVING_KMH and keeps changing
 * (at least MOVING_MIN_UPDATES updates within MOVING_WINDOW_MS).
 */
export const useIsMoving = (speedKmh: number | undefined, lng: number | undefined, lat: number | undefined): boolean => {

  const [moving, setMoving] = useState(false);
  const updates = useRef<number[]>([]);

  useEffect(() => {

    if (lng === undefined || lat === undefined) {

      // position lost: don't leave a running warning without an expiry timer
      updates.current = [];
      setMoving(false);

      return undefined;

    }

    const now = Date.now();

    updates.current = [...updates.current.filter((at) => now - at < MOVING_WINDOW_MS), now];
    setMoving((speedKmh ?? 0) > MOVING_KMH && updates.current.length >= MOVING_MIN_UPDATES);

    // no updates for a while: the movement stopped being reported
    const timer = setTimeout(() => setMoving(false), MOVING_WINDOW_MS);

    return () => clearTimeout(timer);

  }, [speedKmh, lng, lat]);

  return moving;

};
